if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          inputLanguage: this.querySelector('input[name="locale_code"]'),
          inputCountry: this.querySelector('input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
          select: document.querySelector('select[name="country"]'),
          selectLanguage: document.querySelector('select[name="language"]'),
          submitButton: document.getElementById('desktop-localization-wrapper-submit'),
        };

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        if (this.elements.select) {
          this.elements.select.addEventListener('change', this.onItemClick.bind(this));
        }
        if (this.elements.selectLanguage) {
          this.elements.selectLanguage.addEventListener('change', this.onLanguageChange.bind(this));
        }

        if (this.elements.submitButton) {
          this.elements.submitButton.addEventListener('click', () => {
            console.log('submitButton');
            this.onSubmitForm();
          });
        }
      }

      onItemClick(event) {
        event.preventDefault();
        console.log('onItemClick', event.target);

        if (!event.target.classList.contains('language-selector__link--start')) {
          const form = this.querySelector('form');
          this.elements.input.value = event.target.dataset.value;
          if (form) form.submit();
        } else {
          if (event.target.classList.contains('country--link')) {
            this.elements.inputCountry.value = event.target.dataset.value;
          } else if (event.target.classList.contains('language--link')) {
            this.elements.inputLanguage.value = event.target.dataset.value;
          }
        }
      }

      onSubmitForm() {
        const form = this.querySelector('form');
        if (form) form.submit();
      }
    }
  );
}
